import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

export interface DeleteRoomOverlayViewModel {
  autoFocus?: boolean
  confirm: () => void
  closeOverlay: () => void
  isMulti?: boolean
}

export const DeleteRoomOverlayView = React.memo(
  ({
    confirm,
    closeOverlay,
    isMulti = false,
    autoFocus
  }: DeleteRoomOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ConfirmationOverlay.Root
        id="delete-room-overlay"
        isDanger
        autoFocus={autoFocus}
      >
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {isMulti ? t("Room.MultiActions.Delete") : t("Room.Actions.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {isMulti
            ? t("Room.MultiDeleteConfirmation")
            : t("Room.DeleteConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={closeOverlay} />
          <ConfirmationOverlay.Submit onClick={confirm}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
